//流式输出报错文本
export const getErrorText = (code) => {
  const codeMap = {
    18002: '当前数智员工已过期，<a href="/v2/#/user/employeePurchase">点击此处去购买数智员工</a>。',
    18005:
      '请购买数智员工对应的应用后再使用，<a href="/v2/#/user/employeePurchase">点击此处去购买数智员工</a>。',
    18003: '当前数智员工已过期，请联系管理员购买数智员工。',
    18006: '暂无该应用的使用权限，请联系管理员授权有该应用的数智员工。',
    13034: '积分不足，<a href="/v2/#/user/purchasePlan">点击此处去充值积分</a>。',
    13035: '您已达到团队成员积分限额！',
    13036: '积分不足，请联系管理员充值积分。',
    18009: '当前数智员工已过期，<a href="/v2/#/team/employeePurchase">点击此处去购买数智员工。</a>',
    18010:
      '暂无该应用的使用权限，<a href="/v2/#/team/memberManagement">请授权有该应用的数智员工。</a>',
    13037: '积分不足，<a href="/v2/#/team/teamBuy">点击此处去充值积分。</a>',
    17004: '应用均已下架，切换其他应用进行使用',
    18510: '请上传(.doc/.docx/.ppt/.pptx/.pdf/.md/.txt/.xls/.xlsx)格式的文档再进行AI对话。',
    18511: '暂时还不支持视频和图片的AI对话喔！',
    18505: '没有可用文件。'
  }
  return codeMap[code] || ''
}

//文件流导出报错文本
export const getFileErrorText = (code) => {
  const codeMap = {
    error: '该智能工具所归属的数智员工已过期，请去购买'
  }
  return codeMap[code] || ''
}
